import React, { useState } from 'react';
import { Button, Dialog } from '@biq/apex-ui';
import { DialogActions, DialogContent, DialogContentText } from '@mui/material';
import { jobDetailsDrawerStyle } from './job-manager-details-helper';

interface MissingSmartContractReceiptProps {
    onClose: () => void;
}
const MissingSmartContractReceipt = ({
    onClose,
}: MissingSmartContractReceiptProps): React.JSX.Element => {
    const [open, setOpen] = useState<boolean>(true);

    const handleClose = (): void => {
        setOpen(false);
        onClose();
    };

    return (
        <Dialog
            open={open}
            closable={true}
            onClose={handleClose}
            title={'Missing ID'}
            sx={jobDetailsDrawerStyle.missingReceiptDialog}
        >
            <DialogContent>
                <DialogContentText>
                    This smart contract no longer exists.
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button
                    size='large'
                    onClick={handleClose}
                    autoFocus
                    sx={jobDetailsDrawerStyle.missingReceiptModalButton}
                >
                    CLOSE MODAL
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default MissingSmartContractReceipt;
